var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 14.9695C12.0701 16.2356 10.2153 17 8.18852 17C3.66613 17 0 13.1944 0 8.5C0 3.80558 3.66613 0 8.18852 0C10.2153 0 12.0701 0.764362 13.5 2.03054C14.9299 0.764362 16.7847 0 18.8115 0C23.3339 0 27 3.80558 27 8.5C27 13.1944 23.3339 17 18.8115 17C16.7847 17 14.9299 16.2356 13.5 14.9695Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 14.9695C15.2606 13.4104 16.3771 11.0905 16.3771 8.5C16.3771 5.90946 15.2606 3.58959 13.5 2.03053C14.9299 0.764362 16.7847 0 18.8115 0C23.3339 0 27 3.80558 27 8.5C27 13.1944 23.3339 17 18.8115 17C16.7847 17 14.9299 16.2356 13.5 14.9695Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.502 14.9701C15.2626 13.411 16.379 11.0912 16.379 8.50067C16.379 5.91016 15.2626 3.59031 13.502 2.03125C11.7414 3.59031 10.625 5.91016 10.625 8.50067C10.625 11.0912 11.7414 13.411 13.502 14.9701Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.323b21fa104d0149f50e4562a3ec556a.svg";
export { ForwardRef as ReactComponent };